"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TravelAccommodation() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const airports = ["San Luis Obispo County Regional Airport (SBP) – 5 miles from venue", "Santa Barbara Airport (SBA) – 95 miles south", "San Jose International Airport (SJC) – 210 miles north"];
  const publicTransport = ["SLO Transit buses run throughout the city", "Amtrak Coast Starlight stops at San Luis Obispo station", "Rideshare services (Uber/Lyft) widely available"];
  const hotels = ["Madonna Inn – 1 mile, iconic themed rooms", "Garden Street Inn – 0.5 miles, historic B&B", "Hampton Inn San Luis Obispo – 2 miles, modern amenities"];
  return <section id="travel-accommodation" ref={sectionRef} className="py-24 px-8 !bg-[hsl(158,54%,18%)]">
      <div className="mx-auto max-w-4xl">
        {}
        <div className="mb-16">
          <h2 className="mb-8 text-3xl font-bold text-foreground">Airports</h2>
          <ul className="space-y-4">
            {airports.map((item, i) => <li key={i} data-index={i} className={`group text-foreground transition-opacity duration-[var(--duration-slow)] ${isVisible ? "animate-fade-in-up opacity-100" : "opacity-0"}`} style={{
            animationDelay: isVisible ? `${i * 100}ms` : "0ms"
          }}>
                <span className="relative inline-block after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:bg-accent after:transition-all after:duration-200 group-hover:after:w-full">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        {}
        <div className="mb-16">
          <h2 className="mb-8 text-3xl font-bold text-foreground">
            Public Transport
          </h2>
          <ul className="space-y-4">
            {publicTransport.map((item, i) => <li key={i} data-index={i} className={`group text-foreground transition-opacity duration-[var(--duration-slow)] ${isVisible ? "animate-fade-in-up opacity-100" : "opacity-0"}`} style={{
            animationDelay: isVisible ? `${(i + 3) * 100}ms` : "0ms"
          }}>
                <span className="relative inline-block after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:bg-accent after:transition-all after:duration-200 group-hover:after:w-full">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        {}
        <div>
          <h2 className="mb-8 text-3xl font-bold text-foreground">Hotels</h2>
          <ul className="space-y-4">
            {hotels.map((item, i) => <li key={i} data-index={i} className={`group text-foreground transition-opacity duration-[var(--duration-slow)] ${isVisible ? "animate-fade-in-up opacity-100" : "opacity-0"}`} style={{
            animationDelay: isVisible ? `${(i + 6) * 100}ms` : "0ms"
          }}>
                <span className="relative inline-block after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:bg-accent after:transition-all after:duration-200 group-hover:after:w-full">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}